import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type BannerMode = "auto" | "override" | "hidden";

export interface BannerRow {
  id: string;
  mode: BannerMode;
  text: string;
  cta_label: string | null;
  cta_url: string | null;
}

/** Returns the singleton announcement banner settings (visible to public). */
export function useActiveBanner() {
  return useQuery({
    queryKey: ["active-banner"],
    queryFn: async (): Promise<BannerRow | null> => {
      const { data, error } = await supabase
        .from("announcement_banners")
        .select("id, mode, text, cta_label, cta_url")
        .order("updated_at", { ascending: false })
        .limit(1);
      if (error) {
        console.warn("[banner]", error.message);
        return null;
      }
      const row = (data ?? [])[0];
      if (!row) return null;
      const mode = (["auto", "override", "hidden"] as const).includes(row.mode as BannerMode)
        ? (row.mode as BannerMode)
        : "auto";
      return {
        id: row.id,
        mode,
        text: row.text ?? "",
        cta_label: row.cta_label,
        cta_url: row.cta_url,
      };
    },
    staleTime: 60_000,
  });
}
